var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("notifications", {
    staticClass: "c-notification",
    staticStyle: { "max-width": "100%" },
    attrs: {
      group: "global",
      position: _vm.positionNotification,
      duration: 6000,
      width: 560,
      "animation-name": "s-pop",
      speed: 375,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function ({ item, close }) {
          return [
            _c(
              "aside",
              {
                staticClass: "c-notification_item",
                class: `c-notification_item--${item.type}`,
              },
              [
                _c(
                  "span",
                  { staticClass: "c-notification_icon", on: { click: close } },
                  [
                    _c(
                      "svg",
                      {
                        class: "c-notification_icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 32 32",
                          "svg-inline": "",
                          role: "presentation",
                          focusable: "false",
                          tabindex: "-1",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M8.72 7.28L7.28 8.72 14.563 16l-7.28 7.28 1.437 1.44L16 17.437l7.28 7.28 1.44-1.437L17.437 16l7.28-7.28-1.437-1.44L16 14.563z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                item.title
                  ? _c("h3", { staticClass: "c-notification_title" }, [
                      _vm._v(_vm._s(item.title)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "c-notification_text" }, [
                  _vm._v(_vm._s(item.text)),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }